import React from 'react';
import { bankIntegrationStatus, systemPerformanceData } from '../utils/mockData';
import ChartCard from '../components/dashboard/ChartCard';
import { CheckCircle, AlertCircle, XCircle, Clock, Activity } from 'lucide-react';
const Integrations: React.FC = () => {
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'operational':
        return <span className="inline-flex items-center" data-id="element-1297">
            <CheckCircle size={16} className="mr-1 text-green-500" data-id="element-1298" />
            <span className="text-green-500" data-id="element-1299">Operational</span>
          </span>;
      case 'degraded':
        return <span className="inline-flex items-center" data-id="element-1300">
            <AlertCircle size={16} className="mr-1 text-yellow-500" data-id="element-1301" />
            <span className="text-yellow-500" data-id="element-1302">Degraded</span>
          </span>;
      case 'down':
        return <span className="inline-flex items-center" data-id="element-1303">
            <XCircle size={16} className="mr-1 text-red-500" data-id="element-1304" />
            <span className="text-red-500" data-id="element-1305">Down</span>
          </span>;
      default:
        return null;
    }
  };
  return <div className="space-y-6" data-id="element-1306">
      <div data-id="element-1307">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1308">
          Bank Integration Management
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-1309">
          Monitor and manage all bank API connections and integration statuses.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1310">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1311">
          <div className="flex items-center" data-id="element-1312">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-200" data-id="element-1313">
              <CheckCircle size={24} data-id="element-1314" />
            </div>
            <div className="ml-5" data-id="element-1315">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1316">
                Operational
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1317">
                28
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1318">
          <div className="flex items-center" data-id="element-1319">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-yellow-100 dark:bg-yellow-900 text-yellow-600 dark:text-yellow-200" data-id="element-1320">
              <AlertCircle size={24} data-id="element-1321" />
            </div>
            <div className="ml-5" data-id="element-1322">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1323">
                Degraded
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1324">
                3
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1325">
          <div className="flex items-center" data-id="element-1326">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-red-100 dark:bg-red-900 text-red-600 dark:text-red-200" data-id="element-1327">
              <XCircle size={24} data-id="element-1328" />
            </div>
            <div className="ml-5" data-id="element-1329">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1330">
                Down
              </p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-1331">
                1
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1332">
        <ChartCard title="API Health" subtitle="Response time and errors over the last 24 hours" data={systemPerformanceData} type="line" dataKeys={['responseTime', 'errors']} colors={['#3B82F6', '#EF4444']} data-id="element-1333" />
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6" data-id="element-1334">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4" data-id="element-1335">
            Connection Statistics
          </h3>
          <div className="grid grid-cols-2 gap-4" data-id="element-1336">
            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg" data-id="element-1337">
              <div className="flex items-center" data-id="element-1338">
                <Activity size={20} className="text-blue-500 mr-2" data-id="element-1339" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1340">
                  Success Rate
                </span>
              </div>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white mt-2" data-id="element-1341">
                98.7%
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1342">
                Last 24 hours
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg" data-id="element-1343">
              <div className="flex items-center" data-id="element-1344">
                <Clock size={20} className="text-blue-500 mr-2" data-id="element-1345" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1346">
                  Avg Response
                </span>
              </div>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white mt-2" data-id="element-1347">
                142ms
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1348">
                Last 24 hours
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg" data-id="element-1349">
              <div className="flex items-center" data-id="element-1350">
                <Activity size={20} className="text-blue-500 mr-2" data-id="element-1351" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1352">
                  Daily API Calls
                </span>
              </div>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white mt-2" data-id="element-1353">
                1.2M
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1354">
                +12% from yesterday
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg" data-id="element-1355">
              <div className="flex items-center" data-id="element-1356">
                <Clock size={20} className="text-blue-500 mr-2" data-id="element-1357" />
                <span className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1358">
                  Error Rate
                </span>
              </div>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white mt-2" data-id="element-1359">
                0.08%
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-1360">
                -0.02% from yesterday
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden" data-id="element-1361">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700" data-id="element-1362">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-1363">
            Bank Integration Status
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1364">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1365">
            <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-1366">
              <tr data-id="element-1367">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1368">
                  Bank Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1369">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1370">
                  Connected Users
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1371">
                  Response Time
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-1372">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1373">
              {bankIntegrationStatus.map(bank => <tr key={bank.name} className="hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-1374">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1375">
                    <div className="flex items-center" data-id="element-1376">
                      <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-gray-500 dark:text-gray-300" data-id="element-1377">
                        {bank.name.charAt(0).toUpperCase()}
                      </div>
                      <div className="ml-4" data-id="element-1378">
                        <div className="text-sm font-medium text-gray-900 dark:text-white" data-id="element-1379">
                          {bank.name}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1380">
                    {getStatusBadge(bank.status)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1381">
                    {bank.users.toLocaleString()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-1382">
                    {bank.responseTime}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1383">
                    <button className="text-blue-600 hover:text-blue-900 dark:text-blue-400 dark:hover:text-blue-300 mr-3" data-id="element-1384">
                      Details
                    </button>
                    {bank.status !== 'operational' && <button className="text-green-600 hover:text-green-900 dark:text-green-400 dark:hover:text-green-300" data-id="element-1385">
                        Resolve
                      </button>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
};
export default Integrations;